module.exports = __webpack_public_path__ + "img/blank@2x.260109f.png";